import { useState, useRef, useEffect } from 'react';
import { categories } from '@/data/categories';

export default function CategorySection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (url: string, name: string) => {
    setSelectedCategory(name);
    setDropdownOpen(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="categories" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            Категории
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Категории товаров
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Выберите категорию из выпадающего списка или нажмите на карточку ниже, чтобы перейти к товарам на основном сайте
          </p>
        </div>

        <div className="max-w-md mx-auto mb-12" ref={dropdownRef}>
          <div className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex items-center justify-between px-5 py-3.5 bg-background-100 rounded-2xl border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer text-left"
            >
              <span className={`text-sm ${selectedCategory ? 'text-foreground-800 font-medium' : 'text-foreground-400'}`}>
                {selectedCategory || 'Выберите категорию товаров...'}
              </span>
              <i className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden z-30 max-h-72 overflow-y-auto">
                {categories.map((cat, idx) => (
                  <button
                    key={idx}
                    onClick={() => handleSelect(cat.url, cat.name)}
                    className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer text-left whitespace-nowrap"
                  >
                    <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500">
                      <i className={cat.icon}></i>
                    </span>
                    {cat.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-2xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-background-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 text-center whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            Смотреть все товары
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}